<template>
  <svg
    viewBox="0 0 240 240"
    role="img"
    aria-label="N logo"
    xmlns="http://www.w3.org/2000/svg"
  >
    <defs>
      <mask id="n-cut" maskUnits="userSpaceOnUse">
        <rect width="240" height="240" fill="white" />
        <!-- Cutout gap for the diagonals to create the stencil effect -->
        <polygon points="55,20 135,20 185,220 105,220" fill="black" />
      </mask>
    </defs>

    <!-- Vertical pillars with the gap masked out -->
    <g mask="url(#n-cut)" fill="currentColor">
      <rect x="20" y="20" width="50" height="200" />
      <rect x="170" y="20" width="50" height="200" />
    </g>

    <!-- Double hollow diagonal lines in the style of X -->
    <g fill="currentColor">
      <polygon points="70,20 85,20 135,220 120,220" />
      <polygon points="105,20 120,20 170,220 155,220" />
    </g>
  </svg>
</template>

<script>
export default {
  name: 'NLogo',
};
</script>